import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hierarchy"
export default class extends Controller {
  static targets = ["inputName", "inputDescription", "previewImage", "previewDiv",
     "inputImage", "inputStartPrice", "nothingFound", "listing"]
  static values = {
    persistedSelectedSubcategories: Object,
    directUploadUrl: String
  } 
  selectedSubcategories = [] // name, id?, hierarchy, image_signed_id?
  selectedSubcategory = null
  idCount = 1
  notificationsController = null

  connect() {
    this.populateSelectedSubcategories()
    this.populateListing()
  }

  populateSelectedSubcategories() {
    this.selectedSubcategories = this.persistedSelectedSubcategoriesValue
  }

  populateListing() {
    if(this.moreThanZeroSubcategoriesSelected()) {
      if(this.nothingFoundTarget.classList.contains("hidden") == false) {
        this.nothingFoundTarget.classList.add("hidden")
      }
    } else {
      this.nothingFoundTarget.classList.remove("hidden")
    }
    
    this.listingTarget.innerHTML = ""
    this.listSons(null, 1)
    
    if(this.selectedSubcategory != null) {
      const element = document.firstElementChild.querySelector(`[data-subcategory-id="${this.selectedSubcategory.product_subcategory_id}"]`)
      this.selectedSubcategory.element = element 
      this.selectedSubcategory.element.classList.add("font-bold", "text-blue-500", "underline")
    }
  }
  
  moreThanZeroSubcategoriesSelected() {
    return Object.keys(this.selectedSubcategories).length > 0 && this.selectedSubcategories[1].some((subcategoryCategory) => {
      if(subcategoryCategory["_destroy"] != undefined) {
        if(subcategoryCategory["_destroy"] != null && 
         subcategoryCategory["_destrou"] != "undefined")
        {
          return false
        }
      } else {
        return true
      }
    });
  }

  add(e) {
    e.preventDefault()
    if(this.inputNameTarget.value == "") {
      return
    }
    
    if(!this.canAddSubcategoryAtLevel(this.inputNameTarget.value)) {
      this.showDuplicateError(this.inputNameTarget.value)
      return
    }

    const currentImage = this.inputImageTarget.files[0] || 
      (this.selectedSubcategory?.product_subcategory?.image || null)

    if(this.selectedSubcategory != null) {
      const hierarchy = this.selectedSubcategory.hierarchy

      if(this.selectedSubcategories[parseInt(hierarchy) + 1] == null) {
        this.selectedSubcategories[parseInt(hierarchy) + 1] = []
      }
      
      const foundSubcategory = this.findBestMatchingSubcategory(
        this.inputNameTarget.value, 
        this.selectedSubcategory
      )

      if(foundSubcategory != null) {
        const newEntry = {
          id: foundSubcategory.subcategory.id,
          context_path: foundSubcategory.subcategory.context_path,
          product_category_id: foundSubcategory.subcategory.product_category_id,
          product_subcategory_id: foundSubcategory.subcategory.product_subcategory_id,
          product_subcategory: {
            ...foundSubcategory.subcategory.product_subcategory,
            name: this.inputNameTarget.value,
            description: this.inputDescriptionTarget.value,
            start_price_formatted: this.inputStartPriceTarget.value,
            image: currentImage,
            image_url: currentImage ? null : this.selectedSubcategory?.product_subcategory?.image_url,
            image_from_product_subcategory_id: this.selectedSubcategory.product_subcategory_id
          },
          hierarchy: parseInt(hierarchy) + 1,
          father_product_subcategory_id: this.selectedSubcategory.product_subcategory_id,
          father_product_subcategory: {
            id: this.selectedSubcategory.product_subcategory_id,
            name: this.selectedSubcategory.product_subcategory.name,
            description: this.selectedSubcategory.product_subcategory.description,
            start_price_formatted: this.selectedSubcategory.product_subcategory.start_price_formatted,
            status: "active"
          }
        }
        
        this.selectedSubcategories[foundSubcategory.hierarchy].splice(foundSubcategory.index, 1)
        this.selectedSubcategories[parseInt(hierarchy) + 1].push(newEntry)
      } else {
        this.selectedSubcategories[parseInt(hierarchy) + 1].push({
          product_subcategory_id: `temp_${this.idCount}`,
          context_path: `${this.selectedSubcategory.context_path}/${this.inputNameTarget.value}`,
          product_subcategory: {
            id: `temp_${this.idCount}`,
            name: this.inputNameTarget.value,
            description: this.inputDescriptionTarget.value,
            start_price_formatted: this.inputStartPriceTarget.value,
            status: "active",
            image: currentImage,
            image_url: currentImage ? null : this.selectedSubcategory?.product_subcategory?.image_url,
            image_from_product_subcategory_id: this.selectedSubcategory.product_subcategory_id
          },
          hierarchy: parseInt(hierarchy) + 1,
          father_product_subcategory_id: this.selectedSubcategory.product_subcategory_id,
          father_product_subcategory: {
            id: this.selectedSubcategory.product_subcategory_id,
            name: this.selectedSubcategory.product_subcategory.name,
            description: this.selectedSubcategory.product_subcategory.description,
            start_price_formatted: this.selectedSubcategory.product_subcategory.start_price_formatted,
            status: "active"
          }
        })
      }

      this.idCount++
    } else {   
      if(this.selectedSubcategories[1] == null) {
        this.selectedSubcategories[1] = []
      }

      const productCategoryName = document.querySelector('input[name="product_category[name]"]')?.value || 'Categoria'

      const foundSubcategory = this.findBestMatchingSubcategory(
        this.inputNameTarget.value, 
        {
          hierarchy: 0,
          context_path: `${productCategoryName}`
        }
      )
      
      if(foundSubcategory != null) {   
        this.selectedSubcategories[1].splice(foundSubcategory.index, 1)
        this.selectedSubcategories[1].push({
          id: foundSubcategory.subcategory.id,
          context_path: foundSubcategory.subcategory.context_path,
          product_subcategory_id: foundSubcategory.subcategory.product_subcategory_id,
          product_subcategory: {
            ...foundSubcategory.subcategory.product_subcategory,
            name: this.inputNameTarget.value,
            description: this.inputDescriptionTarget.value,
            start_price_formatted: this.inputStartPriceTarget.value,
            image: this.inputImageTarget.files[0]
          },
          hierarchy: 1,
          father_product_subcategory_id: null
        })
      } else {     
        this.selectedSubcategories[1].push({
          context_path: `${productCategoryName}/${this.inputNameTarget.value}`,
          product_subcategory_id: `temp_${this.idCount}`,
          product_subcategory: {
            id: `temp_${this.idCount}`,
            name: this.inputNameTarget.value,
            start_price_formatted: this.inputStartPriceTarget.value,
            description: this.inputDescriptionTarget.value,
            status: "active",
            image: this.inputImageTarget.files[0]
          },
          hierarchy: 1,
          father_product_subcategory_id: null
        })
      }    

      this.idCount++
    }
    
    this.populateListing()
    const message = `Subcategoria "${this.inputNameTarget.value}" adicionada com sucesso!`
    this.getNotificationsController().showNotification(message, 'success')
  }

  // 🆕 Verifica se pode adicionar subcategoria no nível atual
  canAddSubcategoryAtLevel(subcategoryName) {
    let targetHierarchy
    let targetParentId
    
    // Determina em qual nível e com qual pai vamos adicionar
    if(this.selectedSubcategory != null) {
      targetHierarchy = parseInt(this.selectedSubcategory.hierarchy) + 1
      targetParentId = this.selectedSubcategory.product_subcategory_id
    } else {
      targetHierarchy = 1
      targetParentId = null
    }
    
    // Verifica se já existe uma subcategoria ativa com mesmo nome no mesmo nível
    if(this.selectedSubcategories[targetHierarchy]) {
      const duplicateFound = this.selectedSubcategories[targetHierarchy].find(subcategory => {
        return subcategory.product_subcategory.name === subcategoryName && 
               subcategory.father_product_subcategory_id === targetParentId &&
               subcategory._destroy !== 1  // Ignora as que estão marcadas para delete
      })
      
      if(duplicateFound) {
        return false
      }
    }
    
    return true
  }

  showDuplicateError(subcategoryName) {
    this.inputNameTarget.classList.add('border-red-500', 'bg-red-50')
    
    // Cria ou atualiza mensagem de erro
    let errorElement = document.getElementById('subcategory-duplicate-error')
    if(!errorElement) {
      errorElement = document.createElement('div')
      errorElement.id = 'subcategory-duplicate-error'
      errorElement.className = 'text-red-600 text-sm mt-1 font-medium'
      this.inputNameTarget.parentNode.appendChild(errorElement)
    }
    
    // Define a mensagem contextual
    let contextMessage = ""
    if(this.selectedSubcategory) {
      contextMessage = ` em "${this.selectedSubcategory.product_subcategory.name}"`
    } else {
      contextMessage = " no nível raiz"
    }
    
    errorElement.textContent = `"${subcategoryName}" já existe${contextMessage}. Use um nome diferente.`
    errorElement.style.display = 'block'
    
    setTimeout(() => {
      this.clearDuplicateError()
    }, 5000)
    
    this.inputNameTarget.addEventListener('input', () => {
      this.clearDuplicateError()
    }, { once: true })
  }

  clearDuplicateError() {
    this.inputNameTarget.classList.remove('border-red-500', 'bg-red-50')
    
    const errorElement = document.getElementById('subcategory-duplicate-error')
    if(errorElement) {
      errorElement.style.display = 'none'
    }
  }

  findBestMatchingSubcategory(subcategoryName, parentSubcategory) {
    let bestMatch = null

    const hierarchy = parseInt(parentSubcategory.hierarchy) + 1
    this.selectedSubcategories[hierarchy].forEach((subcategory, index) => {

      const subcategory_path = subcategory.context_path.split("/").slice(0, -1).join("/")
      if(subcategory.product_subcategory.name !== subcategoryName) {
        return
      }
      if(subcategory_path != parentSubcategory.context_path) {
        return
      }
      
      let targetHierarchy = parentSubcategory ? parseInt(parentSubcategory.hierarchy) + 1 : 1
      let targetParentId = parentSubcategory ? parentSubcategory.product_subcategory_id : null
      
      if(parseInt(hierarchy) === targetHierarchy && 
          subcategory.father_product_subcategory_id === targetParentId &&
          subcategory._destroy !== 1) {
        return
      }

      bestMatch = {
        subcategory: subcategory,
        hierarchyArray: this.selectedSubcategories[hierarchy],
        index: index,
        hierarchy: hierarchy
      }
    })
  
    
    if(bestMatch) { 
      if(bestMatch.subcategory._destroy === 1) {
        delete bestMatch.subcategory._destroy
      }
    }
    
    return bestMatch
  }

  root(e) {
    e.preventDefault()

    if(this.selectedSubcategory != null) {
      this.selectedSubcategory.element.classList.remove("font-bold", "text-blue-500", "underline")
    }
    this.selectedSubcategory = null
  }

  remove(e) {
    e.preventDefault()

    if(this.selectedSubcategory == null) {
      return
    }

    this.removeDeep(this.selectedSubcategory.hierarchy, this.selectedSubcategory.product_subcategory_id)
    this.selectedSubcategory = null

    const message = `Subcategoria "${this.inputNameTarget.value}" removida com sucesso!`
    this.getNotificationsController().showNotification(message, 'success')
    this.populateListing()
  }

  change(e) {
    e.preventDefault()

    if(this.selectedSubcategory == null) {
      return
    }

    if(this.inputNameTarget.value == "") {
      return
    }

    // name
    this.selectedSubcategory.element.textContent = 
      this.selectedSubcategory.element.textContent.replace(this.selectedSubcategory.product_subcategory.name, this.inputNameTarget.value)
    this.selectedSubcategory.product_subcategory.name = this.inputNameTarget.value
    this.selectedSubcategories[this.selectedSubcategory.hierarchy].forEach((subcategory) => {
      if(subcategory.product_subcategory_id == this.selectedSubcategory.product_subcategory_id) {
        subcategory.product_subcategory.name = this.inputNameTarget.value
      }
    })

    // description
    this.selectedSubcategory.product_subcategory.description = this.inputDescriptionTarget.value
    this.selectedSubcategories[this.selectedSubcategory.hierarchy].forEach((subcategory) => {
      if(subcategory.product_subcategory_id == this.selectedSubcategory.product_subcategory_id) {
        subcategory.product_subcategory.description = this.inputDescriptionTarget.value
      }
    })

    // start price
    this.selectedSubcategory.product_subcategory.start_price_formatted = this.inputStartPriceTarget.value
    this.selectedSubcategories[this.selectedSubcategory.hierarchy].forEach((subcategory) => {
      if(subcategory.product_subcategory_id == this.selectedSubcategory.product_subcategory_id) {
        subcategory.product_subcategory.start_price_formatted = this.inputStartPriceTarget.value
      }
    })

    // image
    this.selectedSubcategory.product_subcategory.image = this.inputImageTarget.files[0]
    this.selectedSubcategories[this.selectedSubcategory.hierarchy].forEach((subcategory) => {
      if(subcategory.product_subcategory_id == this.selectedSubcategory.product_subcategory_id) {
        subcategory.product_subcategory.image = this.inputImageTarget.files[0]
      }
    })  

    const message = `Subcategoria "${this.inputNameTarget.value}" alterada com sucesso!`
    this.getNotificationsController().showNotification(message, 'success')
  }

  getNotificationsController() {
    this.notificationsController ||= this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller*="notifications"'),
      "notifications"
    )

    return this.notificationsController
  }

  removeDeep(hierarchy, toRemoveSubcategoryId, first = true) {
    if(this.selectedSubcategories[hierarchy] == null) {
      return
    }

    if(first == true) {
      this.selectedSubcategories[hierarchy].forEach((subcategory, index) => {
        if(subcategory.product_subcategory_id == toRemoveSubcategoryId) {
          if(subcategory.product_subcategory_id.toString().startsWith("temp_")){
            this.selectedSubcategories[hierarchy].splice(index, 1) 
          } else {
            this.selectedSubcategories[hierarchy][index]["_destroy"] = 1
          }
        }
        if(this.selectedSubcategories[hierarchy].length == 0) {
          delete this.selectedSubcategories[hierarchy]
        }
      })

      this.removeDeep(parseInt(hierarchy) + 1, toRemoveSubcategoryId, false)
    } else {
      this.selectedSubcategories[hierarchy].forEach((subcategory, index) => {
        if((subcategory.father_product_subcategory_id == toRemoveSubcategoryId)) {       
          if(subcategory.product_category_id.toString().startsWith("temp_")){
            this.selectedSubcategories[hierarchy].splice(index, 1) 
          } else {
            this.selectedSubcategories[hierarchy][index]["_destroy"] = 1
          }

          if(this.selectedSubcategories[hierarchy].length == 0) {
            delete this.selectedSubcategories[hierarchy]
          }
          this.removeDeep(parseInt(hierarchy) + 1, subcategory.product_subcategory_id, false)
        }
      })
    }
  }

  selectSubcategory(e) {
    if(this.selectedSubcategory != null) {
      this.selectedSubcategory.element.classList.remove("font-bold", "text-blue-500", "underline")
    }

    const subcategoryCategory = this.searchSubcategoryCategory(e.target.dataset.subcategoryId, 1)
    this.selectedSubcategory = {
      ...subcategoryCategory,
      element: e.target
    }

    if(this.hasInputNameTarget && this.hasInputDescriptionTarget && this.hasInputStartPriceTarget) {
      this.inputNameTarget.value = subcategoryCategory.product_subcategory.name
      this.inputDescriptionTarget.value = subcategoryCategory.product_subcategory.description
      this.inputStartPriceTarget.value = subcategoryCategory.product_subcategory.start_price_formatted
    }

    if(this.hasPreviewImageTarget && this.hasPreviewDivTarget) {
      if(subcategoryCategory.product_subcategory.image_url != null &&
        subcategoryCategory.product_subcategory.image == null
      ) {
        this.previewImageTarget.src = subcategoryCategory.product_subcategory.image_url
        this.previewDivTarget.classList.remove("hidden")
      } else if (subcategoryCategory.product_subcategory.image != null) {
        const file = subcategoryCategory.product_subcategory.image
        const objectUrl = URL.createObjectURL(file)
        
        this.previewImageTarget.src = objectUrl
        this.previewDivTarget.classList.remove("hidden")
      }
    }

    e.target.classList.add("font-bold", "text-blue-500", "underline")
  }

  searchSubcategoryCategory(subcategoryId, hierarchy) {
    if(this.selectedSubcategories[hierarchy] == null) {
      return null
    }

    const found = this.selectedSubcategories[hierarchy].find(
      (subcategoryCategory) => subcategoryCategory.product_subcategory_id == subcategoryId
    )

    if(found != undefined) { return found }
    return this.searchSubcategoryCategory(subcategoryId, hierarchy + 1)
  }

  findSubcategoriesByContextPath(searchArr, context_path) {
    return searchArr.filter((sub) => sub.context_path.split("/").slice(0, -1).join("/") == context_path)
  }

  listSons(subcategoryIdOfFather, hierarchy) {
    if(this.selectedSubcategories[hierarchy] == null) {
      return
    }

    this.selectedSubcategories[hierarchy].forEach((subcategory, idx) => {
      if (subcategory._destroy == 1) { 
        return 
      }
      
      if(subcategory.father_product_subcategory_id == subcategoryIdOfFather) {
        let element = document.firstElementChild.querySelector(`[data-subcategory-id="${subcategory.product_subcategory_id}"]`)

        if(element == null) {   
          const div = document.createElement("div")
          
          div.attributes.setNamedItem(document.createAttribute("data-action"))
          div.attributes.setNamedItem(document.createAttribute("data-subcategory-id"))
          div.attributes.getNamedItem("data-action").value = "click->hierarchy#selectSubcategory"
          div.attributes.getNamedItem("data-subcategory-id").value = subcategory.product_subcategory_id

          div.classList.add("cursor-pointer", "text-base")

          if(hierarchy != 1) {
            const subcategoriesWithSameContextPath =
              this.findSubcategoriesByContextPath(
                this.selectedSubcategories[hierarchy], 
                subcategory.context_path.split("/").slice(0, -1).join("/")
              )
            const idxSubcategory = subcategoriesWithSameContextPath.findIndex(
              (subcategory_) => subcategory_.id == subcategory.id)
            
            if(idxSubcategory == (subcategoriesWithSameContextPath.length - 1)) {
              div.textContent = "└─" + subcategory.product_subcategory.name
            } else {
              div.textContent = "├─" + subcategory.product_subcategory.name
            }
              
            div.style.marginLeft = `${7 * ((hierarchy - 1) * 2)}px`
          } else {
            div.textContent = subcategory.product_subcategory.name
          }

          this.listingTarget.appendChild(div)
        }
        
        this.listSons(subcategory.product_subcategory_id, parseInt(hierarchy) + 1)
      }
    })
  }

  prepareFormData() {
    const baseName1 = "product_category[product_subcategory_categories_attributes]"
    const baseName2 = "product_category_product_subcategory_categories_attributes"

    let actualProductSubcategoryCategoryIndex = 0
    const inputList = []
    
    const categoryName = document.querySelector('input[name="product_category[name]"]')?.value || 'Categoria'
    
    Object.keys(this.selectedSubcategories).forEach(hierarchy => {
      this.selectedSubcategories[hierarchy].forEach((subcategory, idx) => {
        const contextPath = this.calculateContextPath(subcategory, categoryName)
        const contextInput = document.createElement("input")
        contextInput.type = "hidden"
        contextInput.name = `${baseName1}[${actualProductSubcategoryCategoryIndex}][context_path]`
        contextInput.id = `${baseName2}_${actualProductSubcategoryCategoryIndex}_context_path`
        contextInput.value = contextPath
        inputList.push(contextInput)
        
        if(typeof subcategory["father_product_subcategory_id"] == "string" && subcategory["father_product_subcategory_id"].toString().startsWith("temp_")) {
          this.selectedSubcategories[hierarchy][idx]["father_product_subcategory_context_path"] =
            subcategory.context_path.split("/").slice(0, -1).join("/")
        }
        
        Object.keys(subcategory).forEach(attribute => {
          if(typeof subcategory[attribute] === "object" && subcategory[attribute] !== null) {
            Object.keys(subcategory[attribute]).forEach(subAttribute => {
              if(this.shouldSkipField(subAttribute, subcategory[attribute][subAttribute])) {
                return
              }

              const input = document.createElement("input")
              input.type = "hidden"
              if(subAttribute == "start_price_formatted") {
                const newSubAttribute = "start_price"
                input.name = `${baseName1}[${actualProductSubcategoryCategoryIndex}][${attribute}_attributes][${newSubAttribute}]`
                input.id = `${baseName2}_${actualProductSubcategoryCategoryIndex}_${attribute}_attributes_${newSubAttribute}`
                input.value = subcategory[attribute][subAttribute]
                input.setAttribute("data-mask-type-value", "price") 
              } else {
                input.name = `${baseName1}[${actualProductSubcategoryCategoryIndex}][${attribute}_attributes][${subAttribute}]`
                input.id = `${baseName2}_${actualProductSubcategoryCategoryIndex}_${attribute}_attributes_${subAttribute}`
  
                if(subAttribute == "image") {
                  input.type = "file"
                  input.setAttribute("data-direct-upload-url", this.directUploadUrlValue)
                  const dt = new DataTransfer();
                  dt.items.add(subcategory[attribute][subAttribute]);
                  input.files = dt.files;
                } else if (subAttribute == "image_signed_id") {
                  input.name = `${baseName1}[${actualProductSubcategoryCategoryIndex}][${attribute}_attributes][image]`
                  input.value = subcategory[attribute][subAttribute]
                } else {
                  input.value = subcategory[attribute][subAttribute]
                }
              }

              inputList.push(input)
            })
          } else {
            if(this.shouldSkipField(attribute, subcategory[attribute])) {
              return
            }

            const input = document.createElement("input")
            input.type = "hidden"
            if(attribute == "start_price_formatted") {
              const newAttribute = "start_price"
              input.name = `${baseName1}[${actualProductSubcategoryCategoryIndex}][${newAttribute}]`
              input.id = `${baseName2}_${actualProductSubcategoryCategoryIndex}_${newAttribute}`
              input.value = subcategory[attribute]
              input.setAttribute("data-mask-type-value", "price")
            } else {
              input.name = `${baseName1}[${actualProductSubcategoryCategoryIndex}][${attribute}]`
              input.id = `${baseName2}_${actualProductSubcategoryCategoryIndex}_${attribute}`
              input.value = subcategory[attribute]
            }
            
            inputList.push(input)
          }
        })
        actualProductSubcategoryCategoryIndex ++
      })
    })

    const subcategoriesInputsElement = document.getElementById("subcategories-categories")
    subcategoriesInputsElement.innerHTML = ""
    subcategoriesInputsElement.append(...inputList)
  }

  // 🆕 Método auxiliar simples para calcular context_path
  calculateContextPath(subcategory, categoryName) {
    // 🆕 MELHORIA: Se a subcategoria já tem context_path (dados do servidor), usa ele
    if(subcategory.context_path) {
      return subcategory.context_path
    }
    
    const pathParts = [categoryName]
    let current = subcategory
    const ancestorNames = []
    
    // Sobe na hierarquia coletando nomes dos ancestrais
    while(current && current.father_product_subcategory_id) {
      const father = this.findSubcategoryByIdInSelected(current.father_product_subcategory_id)
      if(father) {
        ancestorNames.unshift(father.product_subcategory.name)
        current = father
      } else {
        break
      }
    }
    
    pathParts.push(...ancestorNames, subcategory.product_subcategory.name)
    return pathParts.join('/')
  }

  // 🆕 Método auxiliar para encontrar subcategoria por ID
  findSubcategoryByIdInSelected(id) {
    for(let hierarchy in this.selectedSubcategories) {
      const found = this.selectedSubcategories[hierarchy].find(sub => 
        sub.product_subcategory_id === id
      )
      if(found) return found
    }
    return null
  }

  shouldSkipField(fieldName, value) {
    if (value === undefined || value === null) {
      return true
    }

    return false
  }
}